import { Plus, Trash2 } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

/**
 * Tabela editável dos e-mails de destino do contrato (`contrato_email`).
 * value: [{ contratoEmailID?, nome, email }]
 * Esses e-mails vêm pré-preenchidos no modal de envio da NF por e-mail.
 */
export default function EmailEditor({ value = [], onChange }) {
  function update(idx, patch) {
    onChange(value.map((row, i) => (i === idx ? { ...row, ...patch } : row)))
  }
  function addRow() {
    onChange([...value, { nome: '', email: '' }])
  }
  function removeRow(idx) {
    onChange(value.filter((_, i) => i !== idx))
  }

  return (
    <div className="space-y-2">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-muted-foreground">
            <tr>
              <th className="font-medium py-1.5 pr-2">Nome</th>
              <th className="font-medium py-1.5 px-2">E-mail</th>
              <th className="w-10"></th>
            </tr>
          </thead>
          <tbody>
            {value.map((row, idx) => (
              <tr key={row.contratoEmailID ?? `novo-${idx}`} className="border-t border-border/60">
                <td className="py-1.5 pr-2">
                  <Input value={row.nome || ''} onChange={(e) => update(idx, { nome: e.target.value })} placeholder="Setor / responsável" className="h-9" />
                </td>
                <td className="py-1.5 px-2">
                  <Input type="email" value={row.email || ''} onChange={(e) => update(idx, { email: e.target.value })} placeholder="financeiro@exemplo.com" className="h-9" />
                </td>
                <td className="py-1.5 text-center">
                  <button onClick={() => removeRow(idx)} title="Remover" className="p-1 rounded hover:bg-destructive/10 text-muted-foreground hover:text-destructive">
                    <Trash2 className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
            {value.length === 0 && (
              <tr><td colSpan={3} className="py-3 text-center text-muted-foreground">Nenhum e-mail cadastrado.</td></tr>
            )}
          </tbody>
        </table>
      </div>
      <Button type="button" variant="outline" size="sm" onClick={addRow}>
        <Plus className="h-4 w-4" /> Adicionar e-mail
      </Button>
    </div>
  )
}
